export const EMPTY_FORM = {
    id : null,
    bankAccount : "",
    country : "",
    accountType : "",
    ifsc : "",
    accountHolderName : "",
    bankBranch:""
}


export const bankAccountTypes = [
    {label : 'Savings', value : 'savings'},
    {label : 'Current', value : 'current'},
]